var AutoSubmitTextArea = require("components/utility/AutoSubmitTextArea");
var CurrentUser = require("lib/account/CurrentUser");
var ReactTooltip = require("react-tooltip");

require('support/reaction_feedback.scss')
class ReactionFeedback extends React.Component {

	constructor(props) {
		super()
		autobind(this);
		this.state = {
			showPopover: props.textOnly, activeEmotion: null,
			reactionFeedbackKey: null, feedbackItemID: null, loading: false
		}
	}

	recordFeedback(emotion, e) {
		$wr.nope(e)

		if (this.state.loading) {
			return;
		}

		if (emotion == this.state.activeEmotion) {
			this.setState({ showPopover: false, activeEmotion: null });
		} else {
			this.setState({ showPopover: true, activeEmotion: emotion }, function() {
				this.submitFeedbackItem();
				this.focusOnTextFeedback();
			}.bind(this));
		}
	}

	submitTextFeedback() {
		this.submitFeedbackItem();
		window.wrNotifications.triggerDropDownNotification({ title: "Thanks!", icon: "star",
			text: "With your help, we get better every day."}, 4000);
		this.setState({ showPopover: false });
	}

	submitFeedbackItem() {
		if (this.state.loading) {
			return;
		}

		var itemData = {
			where: this.props.where, subject_type: this.props.subjectType,
			subject_id: this.props.subjectID, body: this.refs.textBox.text(),
			reaction: this.state.activeEmotion
		}

		var params = { feedback_item: itemData };
		if (this.state.reactionFeedbackKey) {
			params.key = this.state.reactionFeedbackKey;
			this.setState({ loading: true })
			CurrentUser.api().patchFeedbackItem(this.state.feedbackItemID,params, $wr.apiHandler(function(serverResponse) {
				this.setState({ loading: false, feedbackItemID: serverResponse.feedback_item.id });
			}.bind(this)));

		} else {
			itemData.key = Math.random().toString(36).substr(2, 100);;
			this.setState({ reactionFeedbackKey: itemData.key, loading: true })
			CurrentUser.api().postFeedbackItem( params, $wr.apiHandler(function(serverResponse) {
				this.setState({ loading: false, feedbackItemID: serverResponse.feedback_item.id });
			}.bind(this)));
		}
	}

	render() {
		var activeIndex;

		if (this.props.options) {
			var optionList = _.keys(this.props.options);
			var optionMap = this.props.options;
		} else {
			var optionList = ReactionFeedback.DEFAULT_EMOTIONS;
			var optionMap = {};
		}

		if (!this.props.textOnly) {
			var reactionOptions = _.map(optionList, function(emotion, index) {
				var selectOpClassname = "reactionOption";
				if (this.state.activeEmotion != null && emotion != this.state.activeEmotion) {
					selectOpClassname += " inactive";
				} else if (this.state.activeEmotion != null) {
					selectOpClassname += " active";
					activeIndex = index;
				}

				if (optionMap[emotion] && optionMap[emotion].label) {
					selectOpClassname += " b-tooltip";
					var tooltip = optionMap[emotion].label;
					var tooltipTemplate = ReactionFeedback.ALTERNATE_TOOLTIP_TEMPLATE
				}

				return (
					<a className={ selectOpClassname } href="#" key={ emotion } data-tip={ tooltip } 
						data-template={ tooltipTemplate } data-for={"reaction-feedback"}
						onClick={ this.recordFeedback.bind(this, emotion) }>
						<img src={ ReactionFeedback.ICON_LOOKUP[emotion] } />
						<ReactTooltip effect="solid" id={"reaction-feedback"} />
					</a>
				);
			}.bind(this));
		}

		if (this.state.showPopover) {
			var popoverClassName = "popover";

			if (this.props.textOnly) {
				popoverClassName += " textOnly";

			} else {
				var leftPos = ((activeIndex * 50) - 365);
			}

			if (this.props.popover_position) {
				var bottomPositions = [ReactionFeedback.POSITION_BOTTOM, ReactionFeedback.POSITION_BOTTOM_LEFT, ReactionFeedback.POSITION_BOTTOM_RIGHT];
				if (_.contains(bottomPositions, this.props.popover_position)) {
					popoverClassName += " bottom";
				}
				popoverClassName += " " + this.props.popover_position;
			}

			var feedbackPopover = (
				<div className={ popoverClassName } style={{ left: leftPos }} ref="popover">
					<div className="arrow"></div>
					<h3 className="popover-title">
						{ this.props.textTitle }
					</h3>
					<div className="popover-content">
						<AutoSubmitTextArea onSubmit={ this.submitTextFeedback } ref="textBox"
							placeholder={ this.props.placeholder } submitLink={ true } className="form-control" />
					</div>
				</div>
			);
		}

		if (this.props.title) {
			var reactionTitle = (
				<p className="reactionTitle">
					{ this.props.title }
				</p>
			);
		}
		var componentClassName = ""
		if (this.props.component_position) {
			componentClassName += this.props.component_position;
		}
		return (
			<div className={ "reactionFeedback hideOnPrint " + componentClassName } ref="wrap">
				{ reactionTitle }
				<div className={ "reactionRow clearfix "+ componentClassName } ref="reactionRow">
					{ reactionOptions }
				</div>
				{ feedbackPopover }
			</div>
		);
	}

	focusOnTextFeedback() {
		var $popover = $(this.refs.popover);
		var popoverBottom = $popover.offset().top + $popover.height();
		var winHeight = $(window).height();
		var windowBottom = $(window).scrollTop() + winHeight;
		var extraOffset = 20;
		if (windowBottom < popoverBottom + extraOffset) {
			var offset = popoverBottom - winHeight + extraOffset
			$('html, body').animate({ scrollTop: offset }, 'slow');
		}

		$popover.find("textarea").focus();
	}

	checkOutsideClick(e) {
		var $wrap = $(this.refs.wrap);

		if ($(e.target).closest($wrap).length == 0) {
			this.setState({ showPopover: false });
		}
	}

	componentDidMount() {
		$(this.refs.reactionRow).popover();

		$("body").on("click", this.checkOutsideClick);
	}

	componentWillUnmount() {
		$("body").off("click", this.checkOutsideClick);		
	}
}

ReactionFeedback.propTypes = StrictPropTypes({
	where: PropTypes.string.isRequired,
	title: PropTypes.string,
	textTitle: PropTypes.string,
	placeholder: PropTypes.string,
	subjectType: PropTypes.string,
	subjectID: PropTypes.number,
	popover_position: PropTypes.string,
	component_position: PropTypes.string,

	textOnly: PropTypes.bool.isRequired,

	options: PropTypes.object,

	preventManualEntry: PropTypes.bool,
	skipToFallbackSearch: PropTypes.bool,
	onBookSelect: PropTypes.func
});

ReactionFeedback.HAPPY = "happy";
ReactionFeedback.NEUTRAL = "neutral";
ReactionFeedback.SAD = "sad";

ReactionFeedback.DEFAULT_EMOTIONS = [ReactionFeedback.HAPPY, 
	ReactionFeedback.NEUTRAL, ReactionFeedback.SAD]

ReactionFeedback.ICON_LOOKUP = {}
ReactionFeedback.ICON_LOOKUP[ReactionFeedback.HAPPY] = require("reaction-feedback/happy.png")
ReactionFeedback.ICON_LOOKUP[ReactionFeedback.NEUTRAL] = require("reaction-feedback/neutral.png")
ReactionFeedback.ICON_LOOKUP[ReactionFeedback.SAD] = require("reaction-feedback/sad.png")

ReactionFeedback.POSITION_BOTTOM = "position-bottom";
ReactionFeedback.POSITION_BOTTOM_LEFT = "position-bottom-left";
ReactionFeedback.POSITION_BOTTOM_RIGHT = "position-bottom-right";
ReactionFeedback.POSITION_MODAL_BOTTOM_LEFT = "position-modal-bottom-left"
ReactionFeedback.ALTERNATE_TOOLTIP_TEMPLATE = "alternate_tooltip_template"

module.exports = ReactionFeedback;


// WEBPACK FOOTER //
// ./modules/components/support/ReactionFeedback.js